import type { MarketVariants } from '@/lib/i18n'

export type Slide1TitleCopy = {
  eyebrow: string
  // "self-defense" auto-spells to "self-defence" on the Qatar face via useSlideCopy.
  title: string
  subtitle: string
  hintDesktop: string
  hintMobile: string
}

export const copy: MarketVariants<Slide1TitleCopy> = {
  US: {
    eyebrow: 'Chapter 5',
    title: 'Digital self-defense.',
    subtitle:
      '5 simple habits that protect your accounts, money and peace of mind.',
    hintDesktop: 'Tip: Arrow keys also work',
    hintMobile: 'Swipe or tap Next',
  },
  ar: {
    eyebrow: 'الفصل 5',
    title: 'الدفاع عن نفسك رقمياً.',
    subtitle: '5 عادات بسيطة تحمي حساباتك وأموالك وراحة بالك.',
    hintDesktop: 'نصيحة: تعمل مفاتيح الأسهم أيضاً',
    hintMobile: 'اسحب أو اضغط على "متابعة"',
  },
}
